import PopupActions from '../../../actions/PopupActions';
import RoutingActions from '../../../actions/RoutingActions';
import PrintActions from '../../../actions/PrintActions';
import UserStore from '../../../stores/UserStore';
import GuestListStore from '../../../stores/GuestListStore';
import GuestListActions from '../../../actions/GuestListActions';

class PosMenu extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            printedAllLabels: false,
            confirmRelease: false,
        };

        this.printAllLabels = this.printAllLabels.bind(this);
        this.downloadAllLabels = this.downloadAllLabels.bind(this);
    }
    componentDidMount() {
        this.setState({ printedAllLabels: !!this.props.guest && this.props.guest.printedAllLabels });
    }

    printAllLabels() {
        this.setState({ printedAllLabels: true });
        PrintActions.printAllLabels(this.props.guest, this.props.cart);
    }

    downloadAllLabels() {
        this.setState({ printedAllLabels: true });
        PrintActions.previewLabels(this.props.guest, this.props.cart);
    }

    releaseGuestFromPos(guest) {
        if (guest.RegisterId === '0')
            return;

        this.setState({ visible : false }, () => {
            var formData            = UserStore.getApiData();
            formData.Guest_id       = guest.Guest_id;
            formData.ShipmentId     = guest.ShipmentId;
            formData.RegisterId     = UserStore.getState().selectedRegister.id;
            formData.ScheduleId     = guest.ScheduleId;

            GuestListActions.releaseGuestFromPos(formData);
        });
    }

    render() {
        var guest = this.props.guest;
        var selectedLocation = UserStore.getState().selectedLocation;

        if (!guest)
            return null;

        var lspId = UserStore.getState().user.LspId;

        return (
            <div className='pos-sidebar__content'>
                { (lspId === 1079 || lspId === 1091) &&
                    <div
                        className='profile-sidebar__item'
                        onClick={() => { 
                            GuestListStore.setPage('list');
                            RoutingActions.updateRoute('guest-list');
                        }}>
                        Guest List
                    </div>
                }
                <div
                    className='profile-sidebar__item'
                    onClick={() => { PopupActions.viewProfile(guest); }}>

                    Edit { selectedLocation.CompanyFlag === 'Dispensary' ? 'Patient' : 'Customer' } Data
                </div>
                <div
                    className='profile-sidebar__item'
                    onClick={() => { PopupActions.patientJournal(guest); }}>

                    Journal
                </div>
                <div
                    className='profile-sidebar__item'
                    onClick={() => { this.props.setPage('history'); }}>

                    History
                </div>
                <div
                    className='profile-sidebar__item'
                    onClick={() => { PopupActions.open('cart-details', false, guest); }}>

                    Cart Details
                </div>
                { selectedLocation.RegisterForLoyaltyPopup && !guest.IsLoyaltyMember && !guest.IsAnonymous &&
                <div
                    className='profile-sidebar__item'
                    onClick={() => { PopupActions.open('loyalty-registration', false, guest); }}>

                    Register for Loyalty
                </div>                
                }
                { (selectedLocation.ShowLeafLogixLoyalty && selectedLocation.ApplyLoyaltyAsCashValue && !guest.IsAnonymous) &&
                    <div
                        className='profile-sidebar__item'
                        onClick={() => { PopupActions.open('apply-loyalty', false, guest); }}>

                        Apply Loyalty
                    </div>
                }
                <div
                    className='profile-sidebar__item'
                    onClick={this.printAllLabels}
                    style={{ backgroundColor: (this.state.printedAllLabels || guest.printedAllLabels) ? '#a9ea9f' : null }}    
                >

                    Print Cart Labels
                </div>
                <div
                    className='profile-sidebar__item'
                    onClick={this.downloadAllLabels}
                    style={{ backgroundColor: (this.state.printedAllLabels || guest.printedAllLabels) ? '#a9ea9f' : null }}    
                >

                    Download Cart Labels
                </div>                
                { selectedLocation.EnableDelivery &&
                    <div
                        className='profile-sidebar__item'
                        onClick={() => { PopupActions.openDelivery(guest, guest.ShipmentId) }}>

                        Delivery Options
                    </div>
                }
                { (selectedLocation.RemotePay) &&
                    <div
                        className='profile-sidebar__item'
                        onClick={() => { PopupActions.openRemotePay(guest, guest.ShipmentId) }}>

                        <span>
                            RemotePay
                        </span>
                    </div>
                }                 
                { selectedLocation.POSShowRooms &&
                    <div
                        className='profile-sidebar__item'
                        onClick={() => { PopupActions.open('change-room', false, guest); }}>

                        Change Room
                    </div>
                }
                { selectedLocation.POSStatus &&
                    <div
                        className='profile-sidebar__item'
                        onClick={() => { PopupActions.open('change-status', false, guest); }}>

                        Change Status
                    </div>
                }
                <div
                    className='profile-sidebar__item'
                    onClick={() => { PopupActions.open('clear-cart', false, guest); }}>

                    Clear Cart
                </div>

                <div
                    className='profile-sidebar__item'
                    onClick={() => { PopupActions.open('cancel-transaction', false, guest); }}>

                    Cancel Transaction
                </div>

                {selectedLocation.AllowBackdateTransaction &&
                    <div
                        className='profile-sidebar__item'
                        onClick={() => { PopupActions.open('back-date', false, guest); }}>

                        Back Date
                    </div>
                }

                <div
                    className='profile-sidebar__item'
                    onClick={() => { PopupActions.open('transaction-notes', false, guest); }}>

                    Transaction Notes
                </div>

                
                <div
                    className='profile-sidebar__item'
                    onClick={() => { this.setState({ confirmRelease: true }); }}>

                    Release to Guest List
                </div>

                { lspId !== 1079 && lspId !== 1091 &&
                    <div
                        className='profile-sidebar__item'                        
                        onClick={() => { 
                            GuestListStore.setPage('list');
                            RoutingActions.updateRoute('guest-list');
                    }}>

                        { selectedLocation.CompanyFlag === 'Dispensary' ? 'Guest List' : 'Customer List' }
                    </div>
                }


                { this.state.confirmRelease &&
                    <div className='popup popup__transparent'>
                        <div className='popup__content release'>

                            <div className='popup-header'>
                                CONFIRM

                                <div
                                    className='popup-close'
                                    onClick={() => { this.setState({ confirmRelease : false }) }}>

                                    <i className="fa fa-times" aria-hidden="true" />
                                </div>
                            </div>

                            <button
                                onClick={() => { this.setState({ confirmRelease : false }) }}>

                                CANCEL
                            </button>

                            <button
                                onClick={this.releaseGuestFromPos.bind(this, guest)}>

                                RELEASE
                            </button>
                        </div>
                    </div>
                }
	        </div>
        );
    }
}

export default PosMenu;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/PosMenu.react.jsx